import { render, staticRenderFns } from "./boxPlot.vue?vue&type=template&id=5bda11a6&scoped=true&"
import script from "./boxPlot.vue?vue&type=script&lang=js&"
export * from "./boxPlot.vue?vue&type=script&lang=js&"
import style0 from "./boxPlot.vue?vue&type=style&index=0&id=5bda11a6&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda11a6",
  null
  
)

export default component.exports